import { captainBillingRealtime } from "@/features/captain-billing/api/realtime";
import { integrationsRealtime } from "@/features/integrations/api/realtime";
import type { ClientRealtimeFeature } from "@/features/realtime";
import { segmentsRealtime } from "@/features/segments/api/realtime";

/** Every feature that listens on the `client:` channel. Add a feature's `ClientRealtimeFeature` here. */
export const CLIENT_REALTIME_FEATURES: ClientRealtimeFeature[] = [segmentsRealtime, integrationsRealtime, captainBillingRealtime];